export const MerchantSelectionFormStyles = {
  container: 'mt-4',
  icon: 'cursor-pointer mr-2.5',
}
